import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TTransaction } from '../../store/types';

export const convertTransactionFullDate = (date: string) => dayjsCustom(date).format('DD.MM.YYYY / HH:mm');

export const convertTransactionShortDate = (date: string) => dayjsCustom(date).format('DD.MM в HH:mm');

export const converTransactionsToTable = (items: TTransaction[]): TTransaction[] => {
  const transactions: TTransaction[] = items.map((item) => ({
    ...item,
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
  }));

  return transactions;
};
